import { createSingleAction } from 'store/utils';

const SET_EDIT_TRAVEL_EXPENSE_ID = 'SET_EDIT_TRAVEL_EXPENSE_ID';
export const setEditTravelExpenseId = createSingleAction<
string | null, typeof SET_EDIT_TRAVEL_EXPENSE_ID>(SET_EDIT_TRAVEL_EXPENSE_ID);
